<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                Filtros
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="processSearch">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuInit"
                                v-model="menuInit"
                                :close-on-content-click="false"
                                :return-value.sync="dateInit"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateInit"
                                    label="Fecha inicial"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateInit"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuInit = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuInit.save(dateInit)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuEnd"
                                v-model="menuEnd"
                                :close-on-content-click="false"
                                :return-value.sync="dateEnd"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    label="Fecha final"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateEnd"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuEnd = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuEnd.save(dateEnd)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-8">
                        <v-btn
                            class="text-capitalize mb-2 mb-sm-0 mr-2"
                            :href="`/admin/export-expenses?date_init=${dateInit}&date_end=${dateEnd}`"
                        >
                            <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                            Exportar
                        </v-btn>

                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            color="red"
                            text
                            v-show="(dateInit!='') || (dateEnd!='')"
                            @click="cleanSearch('')"
                        >
                            Limpiar
                        </v-btn>
                    </div>
                </form>
            </v-card-text>
        </v-card>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Gastos
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Número</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='id', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='id', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Fecha</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='created_at', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='created_at', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Usuario</span>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtUsuario"
                                                    label="Usuario"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txtUsuario')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Tipo</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='type', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='type', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-select
                                                    v-model="type"
                                                    :items="itemsExpense"
                                                    label="Tipo"
                                                    multiple
                                                    chips
                                                    outlined
                                                    hide-details
                                                    dense
                                                ></v-select>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('type')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Descripción</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='description', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='description', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtDescription"
                                                    label="Descripción"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txtDescription')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Valor</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='value', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='value', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtValue"
                                                    label="Valor"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('txtValue')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Recurrente</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='value', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='value', getExpenses()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                            </div>
                        </th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in expenses" :key="index">
                        <td>{{ item.id  }}</td>
                        <td>{{ (new Date(item.created_at)).toLocaleDateString() }}</td>
                        <td>{{ item.user?.name }}</td>
                        <td>{{ item.type }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ roundDecimals(item.value) }}</td>
                        <td>{{ (item.recurring_reg)? 'Si' : 'No' }}</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable" v-if="tmpType=='all'"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
            v-if="tmpType=='all'"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>

<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Gastos',
                    disabled: false,
                    href: '/admin/expenses',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            // filter
            dateInit: '',
            dateEnd: '',
            menuInit: false,
            menuEnd: false,
            seeIn: 'cantidad',
            // data
            expenses: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            // stock
            dialogStock: false,
            // tabla de productos
            search: '',
            headers: [
                { text: 'Producto', align: 'start', value: 'name' },
                { text: 'Unidad de medida', value: 'unit' },
                { text: 'Cantidad', value: 'quantity' },
                { text: 'Costo unitario', value: 'cost_min' },
                { text: 'Total valorado', value: 'total' }
            ],
            listProduct: [],
            tmpTotal: 0,
            // filters
            orderType: 'DESC',
            orderBy: 'created_at',

            type: '',
            txtDescription: '',
            txtUsuario: '',
            txtValue: '',
            txtRecurring: '',
            tmpType: 'all',
            itemsExpense: ['Sueldos personal', 'servicios básicos', 'alquileres', 'Insumos y materiales', 'otros'],
        }
    },
    props: ['slug', 'money'],
    mounted() {
        this.getExpenses()
        //this.getDataProducts()

        this.headers[3].text = 'Costo unitario en ' + this.money
        this.headers[4].text = 'Total valorado en ' + this.money
    },
    methods: {
        calculateTotal() {
            return 0;

            this.tmpTotal = 0
            this.listProduct.forEach(item => {
                this.tmpTotal += item.quantity * item.cost_min
            })
        },
        /** sdfdsf */
        cleanSearch(type='') {
            if (type=='') {
                if ( (this.seeIn !== '') || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.dateInit = '';
                    this.dateEnd = '';
                    this.seeIn = 'cantidad';
                    this.page = 1;
                    this.getExpenses()
                }
            } else {
                switch (type) {
                    case 'type':
                        this.type = "";
                        this.getExpenses();
                        break;
                    case 'txtDescription':
                        this.txtDescription = ''
                        this.getExpenses();
                        break;
                    case 'txtValue':
                        this.txtValue = ''
                        this.getExpenses();
                        break;
                    case 'txtRecurring':
                        this.txtRecurring = ''
                        this.getExpenses();
                        break;
                    case 'txtUsuario':
                        this.txtUsuario = '';
                        this.getExpenses();
                        break;
                    default:
                        break;
                }
            }
        },
        changePage(event) {
            this.page = event;
            this.getExpenses();
        },
        processSearch() {
            this.page = 1
            this.getExpenses()
        },
        /**
         * obtener datos del inventario
         */
        async getExpenses() {
            this.overlay = true
            this.expenses = []
            await axios.get(`/admin/list-expenses?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                            &type=${JSON.stringify(this.type)}
                            &description=${this.txtDescription}
                            &usuario=${this.txtUsuario}
                            &value=${this.txtValue}
            `)
            .then((response) => {
                // console.log(response)

                const resp = response.data
                this.expenses = resp.data

                this.pageTable = `Mostrando <strong>${resp.from??0} - ${resp.to??0}</strong> de un total de <strong>${resp.total}</strong>`
                this.totalPage = resp.last_page

                this.tmpType = 'all'

                this.overlay = false
            })
            .catch((error) => {
                console.log(error)
                this.overlay = false
            })
        },

        /**
         * totales
         */
        sumaTotal(type) {
            return 0;

            let total = 0
            this.expenses.forEach(item => {
                total += (+item[type])
            })
            return total.toFixed(this.numberDecimals)
        },

        /**
         * stock
         */

        roundDecimals(num) {
            return (+num).toFixed(this.numberDecimals)
        }
    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
